'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timer = function timer(timeout) {
    return _q2.default.Promise(function (resolve) {
        return setTimeout(resolve, timeout);
    });
};

var WixApi = function () {
    function WixApi() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$baseEndpoint = _ref.baseEndpoint,
            baseEndpoint = _ref$baseEndpoint === undefined ? 'https://www.wix.com/_api/restaurants-metasites-service' : _ref$baseEndpoint,
            _ref$fetchTimeout = _ref.fetchTimeout,
            fetchTimeout = _ref$fetchTimeout === undefined ? 1000 : _ref$fetchTimeout,
            _ref$fetchOptions = _ref.fetchOptions,
            fetchOptions = _ref$fetchOptions === undefined ? {} : _ref$fetchOptions;

        (0, _classCallCheck3.default)(this, WixApi);

        this._baseEndpoint = baseEndpoint;
        this._fetchTimeout = fetchTimeout;
        this._fetchOptions = fetchOptions;
    }

    (0, _createClass3.default)(WixApi, [{
        key: 'fetchMetasites',
        value: function () {
            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(fetchOptions) {
                var options, query, result;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                options = (0, _extends3.default)({}, this._fetchOptions, fetchOptions);
                                query = ['pageSize', 'cursor'].reduce(function (acc, val) {
                                    if (options[val]) {
                                        acc.push(val + '=' + options[val]);
                                        delete options[val];
                                    }
                                    return acc;
                                }, []).join('&');
                                _context.next = 4;
                                return _q2.default.race([fetch(this._baseEndpoint + '/site-list' + (query ? '?' + query : ''), options).catch(function () {
                                    return null;
                                }), timer(this._fetchTimeout)]);

                            case 4:
                                result = _context.sent;

                                if (!(result && result.ok)) {
                                    _context.next = 9;
                                    break;
                                }

                                _context.next = 8;
                                return result.json();

                            case 8:
                                return _context.abrupt('return', _context.sent);

                            case 9:
                                return _context.abrupt('return', null);

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMetasites(_x2) {
                return _ref2.apply(this, arguments);
            }

            return fetchMetasites;
        }()
    }, {
        key: 'fetchInstance',
        value: function () {
            var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(fetchOptions) {
                var options, msid, query, result, instanceResult;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                options = (0, _extends3.default)({}, this._fetchOptions, fetchOptions);
                                msid = options.msid;

                                delete options.msid;
                                query = msid ? '?msid=' + msid : '';
                                _context2.prev = 4;
                                _context2.next = 7;
                                return _q2.default.race([fetch(this._baseEndpoint + '/instance' + query, options), timer(this._fetchTimeout)]);

                            case 7:
                                result = _context2.sent;

                                if (!(result && result.ok)) {
                                    _context2.next = 13;
                                    break;
                                }

                                _context2.next = 11;
                                return result.json();

                            case 11:
                                instanceResult = _context2.sent;
                                return _context2.abrupt('return', instanceResult.instance);

                            case 13:
                                _context2.next = 17;
                                break;

                            case 15:
                                _context2.prev = 15;
                                _context2.t0 = _context2['catch'](4);

                            case 17:
                                return _context2.abrupt('return', null);

                            case 18:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[4, 15]]);
            }));

            function fetchInstance(_x3) {
                return _ref3.apply(this, arguments);
            }

            return fetchInstance;
        }()
    }]);
    return WixApi;
}();

exports.default = WixApi;
;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-wix-api/dist/WixApi.js
// module id = 739
// module chunks = 0